// extracted by mini-css-extract-plugin
export default {"top":"Proposal_top__hG-6c","box":"Proposal_box__2F1Ll","addButton":"Proposal_addButton__wDjsu"};